/** Timeline T mark geometry on a 256 grid (design §3). */

export const STANDARD_CUT = {
  viewBox: 256,
  logged: { x: 24, y: 32, w: 124, h: 48, rx: 24 },
  playhead: { x: 104, y: 32, w: 48, h: 192, rx: 24 },
  next: { x: 168, y: 32, w: 64, h: 48, rx: 24 },
};

/** Heavier cut for ≤32 px (favicons). */
export const SMALL_CUT = {
  viewBox: 256,
  logged: { x: 16, y: 28, w: 132, h: 60, rx: 24 },
  playhead: { x: 100, y: 28, w: 60, h: 200, rx: 24 },
  next: { x: 180, y: 28, w: 60, h: 60, rx: 24 },
};

export const COLORS = {
  midnight: "#0F1B3D",
  porcelain: "#F3F4F6",
  brassLight: "#B8893B",
  brassDark: "#D2A24C",
  steel: "#5F677A",
  hairline: "#C9CDD8",
  black: "#000000",
  white: "#FFFFFF",
};

function roundedRectPath(r) {
  const { x, y, w, h, rx } = r;
  const rad = Math.min(rx, w / 2, h / 2);
  return [
    `M${x + rad},${y}`,
    `H${x + w - rad}`,
    `A${rad},${rad} 0 0 1 ${x + w},${y + rad}`,
    `V${y + h - rad}`,
    `A${rad},${rad} 0 0 1 ${x + w - rad},${y + h}`,
    `H${x + rad}`,
    `A${rad},${rad} 0 0 1 ${x},${y + h - rad}`,
    `V${y + rad}`,
    `A${rad},${rad} 0 0 1 ${x + rad},${y}`,
    "Z",
  ].join("");
}

/** Union of logged + playhead (no seam). Next stays separate for Brass fill. */
export function unionLoggedPlayhead(cut = STANDARD_CUT) {
  return `${roundedRectPath(cut.logged)}${roundedRectPath(cut.playhead)}`;
}

export function nextPath(cut = STANDARD_CUT) {
  return roundedRectPath(cut.next);
}
